import React from 'react';

import { UsersQuery$variables } from '../graphql/__generated__/UsersQuery.graphql';
import { AllUsersShortQuery } from '../graphql/AllUsersShortQuery';
import { AllUserShortListFragment } from '../graphql/fragments/AllUserShortListFragment';
import { UserShortConnectionFragment } from '../graphql/fragments/UserShortConnectionFragment';
import { UserShortFragment } from '../graphql/fragments/UserShortFragment';
import DataLoader from '../table/DataLoader';

export interface ILoaderUser {
    varRequest: UsersQuery$variables;
    onUpdateData?: (rows: any[], count: number, connectionId: string, columns?: any[]) => void;
    prefixFetchKey?: string;
}

const nameQuery = 'allUsers';

const LoaderUser: React.FC<ILoaderUser> = ({ varRequest, onUpdateData, prefixFetchKey }) => {
    return (
        <DataLoader<UsersQuery$variables, {}>
            query={AllUsersShortQuery}
            fragmentList={AllUserShortListFragment}
            fragment={UserShortFragment}
            fragmentConnection={UserShortConnectionFragment}
            nameQuery={nameQuery}
            onUpdateData={(rows: any[], count: number, connectionId: string) => {
                onUpdateData && onUpdateData(rows, count, connectionId);
            }}
            varRequest={varRequest}
            prefixFetchKey={prefixFetchKey}
        />
    );
};

export default LoaderUser;
